module.exports = __webpack_public_path__ + "static/media/signup-contractor.2d325dea.webp";